import { Injectable } from '@angular/core';
import momentjs from 'moment/min/moment-with-locales.js';

@Injectable({
    providedIn: 'root'
})
export class MomentJsService {
    constructor() {
    }

    format(input:string, format:string) {
        momentjs.locale('ru');
        // momentjs.tz.setDefault("Europe/Moscow")
        if(input){
            if(typeof input === 'string'){
                input = input.replace(/T/, ' ').replace(/\+\d{4}$/, '');
            }
            // console.log('MomentJS:', input);
            return momentjs(input).format(format || 'DD.MM.YYYY')
        }else{
            return '';
        }
    }
}